import { useEffect, useState } from "react";
import { LanguageService } from "../../services/languageService";
import {
  Android,
  Android_en,
  Apk,
  Apk_en,
  Code,
  Code_en,
  COMMUNITY,
  DISCORD,
  FANPAGE,
  HOME,
  Ios,
  Ios_en,
  logo,
  NVmoi,
  NVmoi_en,
  PC,
  PC_en,
  Text,
  Text_en,
} from "../../asset/images";
import video_bgmp4 from "../../asset/video/KV.webm";
import "./banner.scss";

const Banner = () => {
  const [showIOSAlert, setShowIOSAlert] = useState(false);

  const handleIOSClick = (e) => {
    e.preventDefault();
    setShowIOSAlert(true);
  };

  const [translations, setTranslations] = useState({});
  const [links, setLinks] = useState({});
  const [imageSet, setImageSet] = useState({});

  useEffect(() => {
    const langData = LanguageService.getTranslations();
    setTranslations(langData);
    setLinks(LanguageService.getLinks());

    const lang = LanguageService.detectLanguage();
    setImageSet({
      code: lang === "vi" ? Code : Code_en,
      nvmoi: lang === "vi" ? NVmoi : NVmoi_en,
      text: lang === "vi" ? Text : Text_en,
      ios: lang === "vi" ? Ios : Ios_en,
      android: lang === "vi" ? Android : Android_en,
      apk: lang === "vi" ? Apk : Apk_en,
      pc: lang === "vi" ? PC : PC_en,
    });
  }, []);

  return (
    <div className="banner">
      <video src={video_bgmp4} autoPlay loop muted />
      <div className="content">
        <div className="nav_menu">
          <div className="nav_menu__logo">
            <img src={logo} alt="Logo" />
          </div>
          <div className="nav_menu__menu">
            <ul className="nav_menu__menu__bar">
              <a href="/">
                <li>
                  <img src={HOME} alt="Home" />
                  {translations.home}
                </li>
              </a>
              <a href={links.fanpage} target="_blank" rel="noopener noreferrer">
                <li>
                  <img src={FANPAGE} alt="Fanpage" />
                  {translations.fanpage}
                </li>
              </a>
              <a href={links.discord} target="_blank" rel="noopener noreferrer">
                <li>
                  <img src={DISCORD} alt="Discord" />
                  {translations.discord}
                </li>
              </a>
              <a href={links.group} target="_blank" rel="noopener noreferrer">
                <li>
                  <img src={COMMUNITY} alt="Community" />
                  {translations.group}
                </li>
              </a>
            </ul>
          </div>
        </div>

        <a
          className="code"
          href={links.code}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={imageSet.code} alt="Code" />
        </a>

        <div className="text_icon">
          <img src={imageSet.nvmoi} alt="NV Mới" />
        </div>

        <div className="text_Text">
          <img src={imageSet.text} alt="Text" />
        </div>

        <div className="nav_menu__button">
          <ul className="nav_menu__button__bar">
            <a
              className="ten__hover"
              //onClick={handleIOSClick}
              href={links.ios}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.ios} alt="iOS" />
              </li>
            </a>
            <a
              className="ten__hover"
              // onClick={handleIOSClick}
              href={links.android}
              // href="#"
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.android} alt="Android" />
              </li>
            </a>
            <a
              className="ten__hover"
              // onClick={handleIOSClick}
              href={links.apk}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.apk} alt="APK" />
              </li>
            </a>
            <a
              className="ten__hover"
              href={links.pc}
              rel="noopener noreferrer"
            >
              <li>
                <img src={imageSet.pc} alt="PC" />
              </li>
            </a>
          </ul>
        </div>
      </div>

      {showIOSAlert && (
        <div className="custom-alert-overlay">
          <div className="custom-alert">
            <p>{translations.message} </p>
            <button onClick={() => setShowIOSAlert(false)}>
              {translations.closeButton}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
